import { type IntegrationServiceId } from '../../../../../common/integrations'
import React, { type FC, useCallback } from 'react'
import { OnboardingBannerLayout } from '../../Components/OnboardingBannerLayout'
import { OnboardingBannerIntegrationButtons } from '../../Components/OnboardingBannerIntegrationButtons'
import { useTracking } from '../../../../../apps/professional-app/fa/common/tracking/hooks'
import { GrowthTrackEvent } from '../../../../../apps/professional-app/fa/common/tracking'
import { EMAIL_BANNER_COPIES } from '../../../copies/onboardingCopies'

interface EmailOnboardingBannerProps {
  allowedIntegrationIds: IntegrationServiceId[]
  onDismiss?: () => void
  postConnectRedirectPath?: string | ((serviceId: IntegrationServiceId) => string)
}

export const EmailOnboardingBanner: FC<EmailOnboardingBannerProps> = ({ allowedIntegrationIds, onDismiss, postConnectRedirectPath }) => {
  const { trackingClient } = useTracking()

  const handleIntegrationSelect = useCallback(
    (serviceId: IntegrationServiceId) => {
      trackingClient.track({
        eventName: GrowthTrackEvent.UPCOMING_EMAIL_BANNER_INTEGRATION_CLICKED,
        eventDetails: { integrationId: serviceId },
      })
    },
    [trackingClient],
  )

  return (
    <OnboardingBannerLayout title={EMAIL_BANNER_COPIES.title} subtitle={EMAIL_BANNER_COPIES.subtitle} onDismiss={onDismiss}>
      <OnboardingBannerIntegrationButtons
        integrationIds={allowedIntegrationIds}
        postConnectRedirectPath={postConnectRedirectPath}
        onIntegrationSelect={handleIntegrationSelect}
      />
    </OnboardingBannerLayout>
  )
}
